<template>
  <p v-bind="$attrs">{{ props.title }}</p>
</template>

<script setup>
const props = defineProps({ title: { type: String, required: true } });
</script>
